import { AdsResponse } from '../../../../types/api/ads';
import { formatDateTime } from '../../../../helpers/dates';
import { Stack, Button, Avatar } from '@primer/react';
import { PersonIcon, ClockIcon, PaperAirplaneIcon, InfoIcon, ChevronRightIcon } from '@primer/octicons-react'

interface AdDescrSectionProps {
    ads: AdsResponse
    onUserClick: () => void;
    className?: string;
}


const AdDescrSection: React.FC<AdDescrSectionProps> = ({
    ads,
    onUserClick,
    className
}) => {

    const handleAvatarError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = "/icons/avatar.png";
    };

    const data = [
        [
            {
                icon: PersonIcon,
                label: "Пользователь",
                render: () => (
                    <Button
                        onClick={onUserClick}
                        className='!h-[20px]'
                        size="small"
                        trailingVisual={ChevronRightIcon}
                        variant="invisible">
                        <Stack direction="horizontal" align="center" gap="none">
                            <Avatar
                                src={ads.user?.avatar?.preview ?? "/icons/avatar.png"}
                                alt="avatar"
                                size={16}
                                className='w-[16px] aspect-square object-cover object-center rounded-full'
                                onError={handleAvatarError}
                            />
                            <span className="ml-2 text-[14px] text-aloix-grey font-normal">
                                {ads.user?.username}
                            </span>
                        </Stack>
                    </Button>
                )
            },
            { icon: ClockIcon, label: "Дата размещения", value: formatDateTime(ads.createdAt) },
        ],
        [
            { icon: PaperAirplaneIcon, label: "Отклики", value: ads.repliesCount },
            { icon: InfoIcon, label: "Идентификатор", value: ads.number },
            //{ icon: PaperAirplaneIcon, label: "Отклики «Написать»", value: ads.repliesCount },
            //{ icon: BroadcastIcon, label: "Отклики «Позвонить»", value: ads.repliesCount },
        ]
    ]

    const renderRow = (item: any, index: number, isMainContact: boolean) => (
        <div key={item.label || index} className="flex items-center py-2">
            <div className="flex items-center gap-3 w-[160px] flex-shrink-0">
                <item.icon className="w-5 h-5 text-gray-500 flex-shrink-0" />
                <span className="text-[14px] text-aloix-black font-normal whitespace-nowrap">
                    {item.label}
                </span>
            </div>
            <div className="w-[36px] flex-shrink-0"></div>
            {
                item.render
                    ? item.render()
                    : (
                        <span className="text-[14px] text-aloix-grey font-normal">
                            {item.value}
                        </span>
                    )
            }
        </div>
    );

    return (
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${className}`}>
            {data.map((row, rowIndex) => (
                <div key={`row-${rowIndex}`} className="space-y-4">
                    {row.map((item, index) =>
                        renderRow(item, index, true)
                    )}
                </div>
            ))}
        </div>
    );
};

export default AdDescrSection